import LocalStorage from './local-storage'
import CookieConsent from '@/models/cookie-consent'
import Logger from '@/logger'
import { KEYS } from '../data-keys'


/**
 * Name to use for logging.
 * @type {string}
 */
const LOG_NAME = 'Cookie Consent'


/**
 * Local storage gateway for Cookie Consent data.
 * @export CookieConsentStorage
 * @class CookieConsentStorage
 */
export default class CookieConsentStorage extends LocalStorage {
    /**
     * Creates an instance of CookieConsentStorage.
     * @memberof CookieConsentStorage
     */
    constructor() {
        super({
            table: 'cookie-consent',
            keys: [ KEYS.cookieConsent ],
        })
    }

    /**
     * Gets the selected context from local storage if there is one.
     * @returns {Promise<CookieConsent>} The value.
     */
    async getAsync() {
        const value = await this.getValueAsync(KEYS.cookieConsent)
        const consent = new CookieConsent(value)

        Logger.logObject(value, 'Retrieved cookie data from local storage', LOG_NAME)
        Logger.logObject(consent, 'Returning converted cookie data', LOG_NAME)

        return consent
    }

    /**
     * Set cookie consent data.
     * @param {CookieConsent} consent
     * @returns {Promise<CookieConsent>} The value.
     */
    async setAsync(consent) {
        Logger.logObject(consent, 'Updating cookie consent data', LOG_NAME)

        const value = await this.upsertDataAsync(KEYS.cookieConsent, consent)

        return new CookieConsent(value)
    }
}
